export default {
  countryRegions: ((state, getters, rootState) => (countryId, bucket = 'entities') => {
    if (!rootState[bucket].countries[countryId]) {
      return [];
    }
    return rootState[bucket].countries[countryId].regions.map(id => rootState.entities.regions[id])
  }),
  countryPartners: ((state, getters, rootState) => (countryId, bucket = 'entities') => {
    if (!rootState[bucket].countries[countryId]) {
      return [];
    }
    return rootState[bucket].countries[countryId].partners.map(id => rootState.entities.partners[id])
  }),
  selectedCountry: (state) => { return state.selectedCountry },
};


// WEBPACK FOOTER //
// ./src/store/countries/getters.js